import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface PhoneCodeSelectProps {
  value: string | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  phoneCodes?: { iso2: string; code: string }[]; // 追加してありますが、使用していません
}

const PhoneCodeSelect = React.forwardRef<
  HTMLInputElement,
  PhoneCodeSelectProps
>(({ value, onChange, onBlur, phoneCodes }, _ref) => {
  const handleChange = (
    phone: string,
    country: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange(phone);
  };

  return (
    <PhoneInput
      country="jp"
      value={value}
      onChange={handleChange}
      inputProps={{
        onBlur,
      }}
      {...({ separateDialCode: true } as any)}
      containerClass="react-phone-input-2"
      inputClass="w-full border border-black p-1"
    />
  );
});
PhoneCodeSelect.displayName = 'PhoneCodeSelect';

export { PhoneCodeSelect };
